/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" */
import { TFunction } from 'next-i18next';

import { ExpanderLabels } from './index';

export const getExpanderLabel = ({
    t,
    truncateText,
    expanderLabels,
}: {
    t: TFunction;
    truncateText: boolean;
    expanderLabels?: ExpanderLabels;
}) => {
    const {
        seeMore = t('See more', {
            context: 'Truncated text',
        }),
        seeLess = t('See less', {
            context: 'Truncated text',
        }),
    } = expanderLabels || {};

    return truncateText ? seeMore : seeLess;
};
